import React from "react";
import { AbsoluteFill } from "remotion";
import ProjectCard from "../components/ProjectCard";
import { SceneHeading, SceneTint } from "../components/SceneChrome";
import { projectById } from "../data/resume";

// Scene 2 — Zip Co (12–22%): a 2-card deck, purple tint.
const Scene2ZipCo: React.FC = () => {
  const contentful = projectById("zip-contentful");
  const dotnet = projectById("zip-dotnet");
  const ContentfulIcon = contentful.icon;

  return (
    <AbsoluteFill style={{ backgroundColor: "#181818" }}>
      <SceneTint color={contentful.color} enterFrame={4} />
      <SceneHeading
        title="Zip Co Limited — Fullstack Engineer"
        subtitle="2018–2020 · 2024–present"
        color={contentful.color}
        enterFrame={2}
      />
      <AbsoluteFill
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: 80,
          paddingTop: 60,
        }}
      >
        <ProjectCard
          title={contentful.title}
          client={contentful.client}
          color={contentful.color}
          bullets={contentful.bullets}
          stack={contentful.stack}
          size="deck"
          enterFrame={10}
          flipFrame={58}
          icon={<ContentfulIcon sx={{ fontSize: 52 }} />}
        />
        <ProjectCard
          title={dotnet.title}
          client={dotnet.client}
          color={dotnet.color}
          bullets={dotnet.bullets}
          stack={dotnet.stack}
          size="deck"
          enterFrame={22}
          flipFrame={68}
          icon={<ContentfulIcon sx={{ fontSize: 52 }} />}
        />
      </AbsoluteFill>
    </AbsoluteFill>
  );
};

export default Scene2ZipCo;
